/* eslint-disable spire/export-styles */

import React, { FC } from "react";
import styled, { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Hidden from "@insite/mobius/Hidden";
import getColor from "@insite/mobius/utilities/getColor";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import { connect } from "react-redux";

type Props = WidgetProps;

export interface HeaderLinksContainerStyles {
    container?: InjectableCss;
    contact?: InjectableCss;
    signIn?: InjectableCss;
    cart?: InjectableCss;
    contactSignInContainer?: InjectableCss;
}

const styles: HeaderLinksContainerStyles = {
    container: {
        css: css`
            display: flex;
            justify-content: flex-end;
        `,
    },
    contact: {
        css: css`
            margin: 0 8px;
            align-self: center;
        `,
    },
    signIn: {
        css: css`
            margin: 0 8px 0 10px;
            align-self: center;
        `,
    },
    cart: {
        css: css`
            margin-left: 0px;
            align-self: center;
        `,
    },
    contactSignInContainer: {
        css: css`
            display: flex;
        `,
    },
};

export const headerLinksContainerStyles = styles;

const HeaderLinksContainer: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <Hidden below="lg" {...styles.contactSignInContainer}>
                <StyledWrapper {...styles.contact}>
                    <Zone contentId={id} zoneName="contact" />
                </StyledWrapper>
                <StyledWrapper {...styles.signIn}>
                    <Zone contentId={id} zoneName="signIn" />
                </StyledWrapper>
            </Hidden>
            <StyledWrapper {...styles.cart}>
                <Zone contentId={id} zoneName="cart" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

const headerLinksContainer: WidgetModule = {
    component: HeaderLinksContainer,
    definition: {
        group: "Common",
    },
};

export default headerLinksContainer;
